<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-data
          titulo="Información de la DD.JJ."
          :datos="compraImpuestoDatos">
        </app-data>

        <b-card header="Cuentas" v-if="compraImpuestoCuentasDatos && compraImpuestoCuentasDatos.length != 0" >
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="compraImpuestoCuentasDatos" 
              :fields="compraImpuestoCuentasFields">
            <template v-slot:cell(montoBase)="data">
              {{ data.item.montoBase | moneda }}
            </template>
            <template v-slot:cell(montoImpuestos)="data">
              {{ data.item.montoImpuestos | moneda }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="data-goback-btn" @click.prevent="goBack">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Data from  '../shared/tableData.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'comprasImpuestos/getField',
  mutationType: 'comprasImpuestos/updateField',
});

export default {
  name: 'CompraImpuestoData',
  components: {
    appData: Data,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      compraImpuestoId: 0,
      
      fields: [
        {key: 'campo'},
        {key: 'valor'},
      ],

      compraImpuestoCuentasFields: [
        { 
          key: 'codigoCuenta',
          label: 'Código'
        },
        { key: 'cuenta' },
        { 
          key: 'montoBase',
          label: 'Monto',
          class: 'text-right' 
        },
      ],
    }
  },
  created() {
    this.compraImpuestoId = this.$route.params.id;

    this.$store.dispatch('comprasImpuestos/getDatos', this.compraImpuestoId)
      .catch(error => this.showErrorMsj(error));
  },  
  computed: {
    ...mapFields([
      'compraImpuestoDatos',
      'compraImpuestoCuentasDatos',
    ]),
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>
